import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { LEAVE_BALANCE } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, POST, PUT, DELETE } = HTTP_METHODS;
const { LEAVE_BALANCE_REQUEST, LEAVE_BALANCE_USER_ALL } = LEAVE_BALANCE;

export const leaveBalanceApi = createApi({
  reducerPath: 'leaveBalanceApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    getLeaveBalance: builder.query({
      query: (data) => ({ url: `${LEAVE_BALANCE_REQUEST}${buildQueryString(data)}`, method: GET })
    }),
    addLeaveBalance: builder.mutation({
      query: (data) => ({ url: LEAVE_BALANCE_REQUEST, method: POST, data })
    }),
    deleteLeaveBalance: builder.mutation({
      query: (id) => ({
        url: `${LEAVE_BALANCE_REQUEST}/${id}`,
        method: DELETE
      })
    }),
    editLeaveBalance: builder.mutation({
      query: (data) => ({
        url: `${LEAVE_BALANCE_REQUEST}/${data?.id}`,
        method: PUT,
        data: data?.data
      })
    }),
    getUserAllLeaveBalance: builder.query({
      query: (data) => ({ url: `${LEAVE_BALANCE_USER_ALL}${buildQueryString(data)}`, method: GET })
    })
  })
});

export const {
  useGetLeaveBalanceQuery,
  useAddLeaveBalanceMutation,
  useEditLeaveBalanceMutation,
  useDeleteLeaveBalanceMutation,
  useGetUserAllLeaveBalanceQuery
} = leaveBalanceApi;
